var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H22V33H12C5.37258 33 0 27.6274 0 21V12Z",
    fill: "url(#paint0_linear_329_4382)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6508 16.4966L15.9137 19.5307C16.0208 19.6303 16.0294 19.8005 15.9329 19.911C15.8365 20.0215 15.6715 20.0303 15.5645 19.9308L12.0863 16.6964C11.9712 16.5894 11.9713 16.4031 12.0865 16.2962L15.5647 13.069C15.6719 12.9696 15.8368 12.9787 15.9331 13.0892C16.0294 13.1998 16.0207 13.37 15.9135 13.4694L12.6508 16.4966Z",
    fill: "#2E2E2E",
    stroke: "#2E61D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65083 16.4966L11.9137 19.5307C12.0208 19.6303 12.0294 19.8005 11.9329 19.911C11.8365 20.0215 11.6715 20.0303 11.5645 19.9308L8.08625 16.6964C7.97116 16.5894 7.97126 16.4031 8.08646 16.2962L11.5647 13.069C11.6719 12.9696 11.8368 12.9787 11.9331 13.0892C12.0294 13.1998 12.0207 13.37 11.9135 13.4694L8.65083 16.4966Z",
    fill: "#2E2E2E",
    stroke: "#2E61D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_329_4382",
    x1: 33,
    y1: 20,
    x2: -2,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E61D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E61D6",
    stopOpacity: 0.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.3ca427a1d567f94239957ba0fdfc659c.svg";
export { ForwardRef as ReactComponent };